export const is3WSD18 = false;
export const isFLN = false;
export const isSSM508 = false;
export const isFOOKLEEUNION = false;
export const isHY202318 = false;
export const isTCM941 = false
export const isCosmic= false
export const is2WSD23= false;
export const is1026E24T =false;
export const is1858EM23T= false;
export const is2501ths = false;
export const is2423nks = false;
export const isTcn912 = true;
export const isDev = false;
export const isMtrc1702dcsms = false;
export const isHkis4s = false
export const isDe202406 =false
export const isHKUSTTH = false;
export const isCKP = false;




export const COOKIESPREFIX = 'CONSTRUCTIONDASHBOARD';

export const isOnlyTracking = isCosmic
export const showTrackingLocation = isCosmic||is2WSD23
export const showTrackingStatus = isCosmic
export const showTrackingPhoto = isCosmic
export const isHideMenuButton = true
export const defaultLogoName = isCosmic ? 'Aquila' : 'Novalinx'
export const isWatchDangerZone = isHKUSTTH||isSSM508||is2WSD23||is2501ths||is2423nks||isHkis4s||isCKP;
export const isWatchMinutesDisplayOfflineThreshold = 30;
export const isWatchDisplayStandStill = is1858EM23T;
export const watchLatOffset = 0.0028
export const watchLngOffset = -0.005
export const showTrackingExaminationDate = is2WSD23
export const showPermitLocation = true
export const isSmartTag = is2501ths || is2423nks ||isSSM508
export const isSmartTagShowDangerZone = is2501ths || is2423nks || isSSM508 || isHKUSTTH
export const isSmartTagShowDangerZoneAlertOnly = is2501ths || is2423nks || isHKUSTTH
export const isShowRiskAssessment = isTcn912
export const isAddTowerCraneLifting = isDev
export const isAddSSM508TowerCrane = isSSM508 || isHKUSTTH
export const isDashboardAlertPlaceTopRight = isDev
export const isNewPermitSystemWithSigniture = true//isHKUSTTH || isSSM508 || isHkis4s || isMtrc1702dcsms || isTcn912 || is2WSD23 || isHKUSTTH || isTCM941
export const enablePhotoManagement = isMtrc1702dcsms
export const enableGpsTracking = isMtrc1702dcsms
export const enableSiteAccessControl = isMtrc1702dcsms
export const enableBimModelViewer = isMtrc1702dcsms
export const enableEnvironmentalInformation = isMtrc1702dcsms

export const DEFAULT_PROJECT_ID =  
    isFLN?'FLN'
    :is3WSD18?"3WSD18"
    :isSSM508?'SSM508'
    :isFOOKLEEUNION?'Fook Lee Construction Co., Ltd. Union Contractors Ltd.'
    :isHY202318?'HY/2023/18'
    :isTCM941?'tcm941'
    :isCosmic? 'Cosmic'
    :is2WSD23? '2/WSD/23'
    :is1026E24T? '1026E24T'
    :is1858EM23T?'1858EM23T'
    :is2501ths?'2501ths'
    :is2423nks?'2423nks'
    :isTcn912? 'tcn912'
    :isMtrc1702dcsms? 'mtrc1702.dcsms'
    :isHkis4s? 'hkis4s'
    :isDe202406? 'de202406'
    :isHKUSTTH? 'hkustth'
    : isCKP? 'ckp'
    :'Project 1';

export const isHideCMP = isCosmic||false
export const isHideSummary = isCosmic||false
export const isHideDangerZone=is1858EM23T||is1026E24T||isCosmic||is3WSD18||isHY202318||isFOOKLEEUNION||is2501ths||is2423nks||isTcn912||isDe202406||isHKUSTTH||isCKP||false
export const isHideConfinedSpace=is1858EM23T||is1026E24T||isCosmic||isTCM941||is3WSD18||isHY202318||isFOOKLEEUNION||is2501ths||is2423nks||isHkis4s||isHKUSTTH||false
export const isHideSmartLock = is1858EM23T||is1026E24T||isCosmic||is3WSD18||isHY202318||isDe202406||isHKUSTTH||false
export const isHideSmartWatch = isCosmic||isDe202406||false
export const isHideSmartCamera= is1858EM23T||is1026E24T||isCosmic||is3WSD18||false
export const isHidePermit= is1858EM23T||isCosmic||is3WSD18||is2501ths||is2423nks||isDe202406||isHKUSTTH||false
export const isHideTracking= is1858EM23T||is1026E24T||is3WSD18||is2501ths||is2423nks||isDe202406||isHKUSTTH||false
export const isHideVR = is1858EM23T||is1026E24T||is3WSD18||isHY202318||isCosmic||is2501ths||is2423nks||isHkis4s||isDe202406||isMtrc1702dcsms||isHKUSTTH||isCKP||false
export const isHidePermitCreateDate = is2WSD23
export const isPrintWhiteMode = is2WSD23||isTcn912||isMtrc1702dcsms||isHkis4s||isHKUSTTH
export const isHideReportSnapShot = is2WSD23
export const isCMPHideInactiveWatch = (!isSmartTag)
export const isShowPermitAttachment = is2WSD23
export const alertConditionsList = is1858EM23T ? ['Pending','Real Alert','Unintended','Testing']:['Pending','Testing','Resolved']
export const enableDownloadTrackingAsExcel = isCosmic

export const CMP_DEFAULT_FILTER= isFOOKLEEUNION? '7 Days' :"Today"

export const REFRESH_INTERVAL = 1000*30 //30 seconds 

export const PERMIT_DEFAULT_TYPE = 
    isTCM941?['Sham Shui Po','Tsuen Wan','Kwai Tsing']
    :isFOOKLEEUNION ? ['TCM942','TCM932','901', 'TCN922']
    :['Permit to Work', 'Permit to Move', 'Permit to Operate', 'Other Permit']

export const RISKASSESSMENT_DEFAULT_TYPE =  [
    'Safety Risk',
    'Health Risk',
    'Environmental Risk',
    'Finalcial Risk',
    'Other Risk',
]

const server_ips = {
    prod:'',
    local:'http://localhost:5001',
    tcn912:'http://95.40.48.77',
    ssm508:'http://54.169.14.65',
    fooklee:'http://18.141.147.126',
    hkis4s: 'http://95.40.61.51',
    mtrc1702dcsms: 'http://18.162.52.189',
    hkustth: 'http://95.40.22.104',
    is1858EM23T:'http://43.199.32.2',
    '2wsd23':'http://13.213.77.103',
    "de202406":'http://16.162.163.104',
    '2501ths':'http://43.199.143.85',
    'ckp':'http://54.46.125.99',
}
export const server_ip = server_ips.prod
//demo:'http://18.140.58.38:3000'
//3WSD:'http://18.143.73.17'
//FLN: 'http://13.212.187.22'
//FOOKLEEUNION: 'http://18.143.149.108'
//HY/2023/18: 'http://13.250.51.217'
//tcm941: 'http://54.151.167.226'
//cosmic: 'http://13.250.64.40'
//2/WSD/23: 'http://13.229.101.255'
//1026E24T 'http://13.215.162.68'
//2423nks 'http://16.163.156.196'

export const GOOGLEMAPAPIKEY = 'AIzaSyBP6_3_nGzAaL1ti6OmphwQvqFI5VhYguc';